import { motion, useTransform, useScroll } from "framer-motion";
import { useRef } from "react";
import '../Styles/Project.css';

import Birla from '../images/Project images/Birla.webp';
import Muppa from '../images/Project images/Muppa.webp';
import Sage from '../images/Project images/Sage.webp';
import PlanIT from '../images/Project images/PlanIT.webp';
import Iris from '../images/Project images/Iris.webp';
import Nirvana from '../images/Project images/Nirvana.webp';
import Ucchvas from '../images/Project images/Ucchvas.webp';
import Vybe from '../images/Project images/Vybe.webp';
import Wave from '../images/Project images/Wave.webp';
import Supadha from '../images/Project images/Supadha.webp';
import A_Fiber from '../images/Project images/A_Fiber.webp';
import MNM from '../images/Project images/mnm.webp';
import Cinq from '../images/Project images/cinq.webp';
import Raghava from '../images/Project images/raghava.webp';
import Garuda from '../images/Project images/garuda.webp';
import Altas from '../images/Project images/altas.webp';

const Example = () => {
  return (
    <div >
      <HorizontalScrollCarousel />
    </div>
  );
};

const HorizontalScrollCarousel = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

const x = useTransform(scrollYProgress, [0, 1], ["95%", "-50%"]);

  return (
    <section ref={targetRef} className="carousel-section">
      <div className="sticky-section">
        <div className="info">
          <h2>Projects</h2>
          <p>I have worked on diverse WordPress projects, ranging from real estate websites to e-commerce platforms and business portfolios. With nearly two years of experience as a WordPress developer, I specialize in creating responsive, SEO-friendly, and high-performing websites. My expertise includes optimizing site performance for better user experience.</p>
        </div>
        <motion.div style={{ x }} className="carousel-items">
          {cards.map((card) => {
            return <Card card={card} key={card.id} />;
          })}
        </motion.div>
      </div>
    </section>
  );
};

const Card = ({ card }) => {
  return (
    <div className="card">
      <a href={card.link} target="_blank" rel="noopener noreferrer">
        <div
          style={{
            backgroundImage: `url(${card.url})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="card-image"
        ></div>
        <div className="card-content">
          <p className="card-text">{card.title}</p>
        </div>
      </a>
    </div>
  );
};

export default Example;

const cards = [
  {
    url: MNM,
    title: "M + M",
    link: "https://marksandmethods.com/",
    id: 1,
  },
  {
    url: Raghava,
    title: "Raghava Developers",
    link: "https://raghava.world/",
    id: 2,
  },
  {
    url: Cinq,
    title: "Cinq",
    link: "https://cinqraghava.world/",
    id: 3,
  },
  {
    url: Garuda,
    title: "Garuda",
    link: "https://garuda.vaishnaoigroup.com/",
    id: 4,
  },
  {
    url: Altas,
    title: "Altas",
    link: "https://hallmarkaltus.com/",
    id: 5,
  },
  {
    url: Birla,
    title: "Birla",
    link: "https://birlaopenmindsbibinagar.com/",
    id: 6,
  },
  {
    url: Muppa,
    title: "Muppa",
    link: "https://muppaprojects.com/",
    id: 7,
  },
  {
    url: Sage,
    title: "Sage",
    link: "http://sagebyraghava.world/",
    id: 8,
  },
  {
    url: Ucchvas,
    title: "Ucchvas",
    link: "http://ucchvas.com/",
    id: 9,
  },
  {
    url: PlanIT,
    title: "PlanIT",
    link: "https://planitholidays.co/",
    id: 10,
  },
  {
    url: Nirvana,
    title: "Nirvana",
    link: "https://nirvanahomespaces.com/",
    id: 11,
  },
  {
    url: Iris,
    title: "Iris",
    link: "https://www.irisbyraghava.world/",
    id: 12,
  },
  {
    url: Vybe,
    title: "Vybe Telecom",
    link: "https://vybetelecom.in/",
    id: 13,
  },
  {
    url: Wave,
    title: "Wave",
    link: "http://wavebyraghava.world/",
    id: 14,
  },
  {
    url: Supadha,
    title: "Supadha",
    link: "https://supadha.com/",
    id: 15,
  },
  {
    url: A_Fiber,
    title: "Apple Fibernet",
    link: "https://applefibernet.com/",
    id: 16,
  },
];
